exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ConfigNoteEditContainer {\n  display: inline-block;\n  margin-left: 20px; }\n  .ConfigNoteEditContainer .textArea {\n    width: 450px;\n    height: 100px;\n    padding: 12px 20px;\n    box-sizing: border-box;\n    border: 1px solid #51AFE8;\n    border-radius: 10px;\n    background-color: #f8f8f8;\n    font-size: 16px;\n    font-family: 'Open Sans', sans-serif;\n    transition: all 0.5s ease; }\n  .ConfigNoteEditContainer .textArea:hover {\n    border-color: #199af6;\n    box-shadow: 0 0 10px #199af6; }\n  .ConfigNoteEditContainer .itemDiv {\n    margin-top: 10px; }\n  .ConfigNoteEditContainer .saveToDeviceBtn {\n    display: block; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/style/ConfigNoteEdit.scss
// module id = 1706
// module chunks = 0